import { User } from "@/types/user/User";
import { formatFromISOString } from "@/utils/date";

/**
 * 信用スコア回復日を表示用の値に変換する
 * @param user
 * @returns string | null M月dd日のフォーマット
 */
export const getCreditScoreRecoveryDateForDisplay = (user: User) => {
  /**
   * キー自体が存在しない場合 null を返す
   * note: 本来 undefined にはならないが、アップデートに伴い型を追加した
   * そのため、初回のauthStore更新までキー自体がが存在しない状態が発生する
   * したがって以下の条件分岐を行なっている
   * 対象のfront-v2アップデート https://gitlab.com/caitech/caisuke-front-v2/-/merge_requests/781
   */
  if (user.creditScoreRecoveryDate === undefined) {
    return null;
  }
  // 自動回復対象ではない場合 null を返す
  if (user.creditScoreRecoveryDate === null) {
    return null;
  }
  return formatFromISOString(user.creditScoreRecoveryDate, "MM/dd");
};
